import { CircleCheckBig, Sparkles } from "lucide-react";

type AuthBrandPanelProps = {
  logo: string;
  title: string;
};

export const AuthBrandPanel = ({ logo, title }: AuthBrandPanelProps) => (
  <aside className="relative hidden min-h-screen overflow-hidden bg-[#152a2b] p-10 text-[#fff9f1] lg:flex lg:w-[46%] lg:flex-col">
    <div className="absolute -right-24 -top-28 size-80 rounded-full border-[34px] border-[#d76f4a]/80" />
    <div className="absolute bottom-[-150px] left-[-80px] size-80 rounded-full bg-[#2d5553]" />
    <div className="relative flex items-center gap-3">
      <img
        className="size-11 rounded-xl object-contain"
        src={logo}
        alt={title}
      />
      <div>
        <p className="text-lg font-semibold tracking-[-0.03em]">{title}</p>
        <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-[#eeb59d]">
          Relationship workspace
        </p>
      </div>
    </div>
    <div className="relative my-auto max-w-md">
      <div className="mb-5 flex size-11 items-center justify-center rounded-2xl bg-[#d76f4a] text-white shadow-lg shadow-[#d76f4a]/20">
        <Sparkles className="size-5" />
      </div>
      <h1 className="text-4xl font-semibold leading-[1.05] tracking-[-0.055em]">
        Make space for the relationships that move your business forward.
      </h1>
      <p className="mt-5 text-base leading-7 text-[#dbe8e4]">
        A focused home for your customers, conversations, deals, and next best
        actions.
      </p>
    </div>
    <div className="relative flex items-center gap-2 text-sm text-[#c5d9d4]">
      <CircleCheckBig className="size-4 text-[#eeb59d]" />
      Built for thoughtful teams
    </div>
  </aside>
);
